export default __webpack_public_path__ + "static/media/TommyDavis.5ac47e43.svg";